import { Checkbox, ComboBox, IComboBox, IComboBoxOption, Stack, TextField } from '@fluentui/react';
import * as React from 'react';
import { IRoom } from '../../../../../Models/Rooms/IRoom';
import { isNumeric } from '../../../../../Tools/Validation';

interface IRoomPropertiesViewProps {
    item: IRoom;

    isLoading: boolean;
    propertyChanged: (key: string, value: any) => void;
    valid: (value: boolean) => void;
}
const options: IComboBoxOption[] = [
    { key: 'Polička', text: 'Polička' },
    { key: 'Svitavy', text: 'Svitavy' },
    { key: 'Litomyšl', text: 'Litomyšl' },
];

export const RoomPropertiesView: React.FunctionComponent<IRoomPropertiesViewProps> = (props) => {
    const propertyChanged = (event?: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
        if (event) {
            var id = (event.target as HTMLInputElement).id;
            props.propertyChanged(id, newValue);
        }
    }

    const onDistrictChange = (event: React.FormEvent<IComboBox>, option?: IComboBoxOption, index?: number, value?: string): void => {
        
        props.propertyChanged("district", value)
    };

    const onOnlineChanged =  
        (ev?: React.FormEvent<HTMLElement | HTMLInputElement>, newChecked?: boolean) => {
            props.propertyChanged("online", newChecked?true:false)
        } 

    const validate = (item: IRoom) => {
        let valid = true;
        if (props.item.name === "") {
            valid = false;
        }
        if (!isNumeric(props.item.latitude)) {
            valid = false;
        }
        if (!isNumeric(props.item.longitude)) {
            valid = false;
        }

        props.valid(valid);
    }

    React.useEffect(() => {
       
        validate(props.item);
    }, [props.item])
    

    return (<Stack tokens={{ childrenGap: 15 }} styles={{ root: { paddingTop: 40 } }}>
        <TextField required id="name" key="name" label="Název" disabled={props.isLoading} value={props.item.name}
            onChange={propertyChanged} />

        <TextField id="description" key="description" multiline label="Popis" disabled={props.isLoading} value={props.item.description}
            onChange={propertyChanged} rows={3} />

        <TextField id="floor" key="floor" label="Patro" disabled={props.isLoading} value={props.item.floor}
            onChange={propertyChanged} />

        <Stack>
            <TextField id="latitude" key="latitude" label="lat." disabled={props.isLoading} value={props.item.latitude.toString()}
                onChange={propertyChanged} />
            <TextField id="longitude" key="longitude" label="log." disabled={props.isLoading} value={props.item.longitude.toString()}
                onChange={propertyChanged} />
        </Stack>

        <ComboBox onChange={onDistrictChange} text={props.item.district} id="district" key="district" allowFreeform options={options.sort((a, b) => {
            if (a.key < b.key) return -1; else return 1;
        })
        } label="Město" />
        <Checkbox label="Online" onChange={onOnlineChanged} checked={props.item.online} />

    </Stack>)
}